import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { GitDiffTreeItem } from '../git-diff-tree.model';

@Component({
  selector: 'y42-git-diff-tree-item-file-cell-renderer',
  templateUrl: './git-diff-tree-item-file-cell-renderer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GitDiffTreeItemFileCellRendererComponent implements AgRendererComponent {
  params!: ICellRendererParams;
  data!: GitDiffTreeItem;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.data = params.data ? params.data : null;
  }

  refresh(_params: ICellRendererParams): boolean {
    return false;
  }
}
